import { Box } from 'shared';

export const ChatMessageSelector = ({
  incoming,
  id,
  children,
}: {
  incoming: boolean;
  id: string;
  children: React.ReactNode;
}) => (
  <Box
    id={id}
    style={{
      display: 'flex',
      gap: '0.5rem',
      width: '100%',
      alignItems: 'center',
      justifyContent: incoming ? 'start' : 'end',
      flexDirection: incoming ? 'row' : 'row-reverse',
    }}
    data-testid="chat-message-selector"
  >
    {children}
  </Box>
);
